export default __webpack_public_path__ + "static/media/Bloodskew.b04bbacb.jpg";